import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_collapsible_4615ddd5__ from "@radix-ui/react-collapsible";
const Collapsible = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_collapsible_4615ddd5__.Root;
const { CollapsibleTrigger } = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_collapsible_4615ddd5__;
const { CollapsibleContent } = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_collapsible_4615ddd5__;
export { Collapsible, CollapsibleContent, CollapsibleTrigger };

//# sourceMappingURL=index.js.map